import React from 'react';

// T0 — Carte partagée (dark-mode natif). Remplace les Card redéfinies dans chaque page.
// Transmet les props restantes au div (ex: onClick) pour rester polyvalente.
export const Card = ({ children, className = '', ...props }) => (
  <div className={`bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 ${className}`} {...props}>
    {children}
  </div>
);

// Transmettent aussi les props restantes (ex: onClick) — indispensable pour les en-têtes cliquables/dépliables.
export const CardHeader = ({ children, className = '', ...props }) => (
  <div className={`px-6 py-4 border-b border-gray-200 dark:border-gray-700 ${className}`} {...props}>
    {children}
  </div>
);

export const CardTitle = ({ children, className = '', ...props }) => (
  <h3 className={`text-lg font-semibold text-gray-900 dark:text-white ${className}`} {...props}>
    {children}
  </h3>
);

export const CardContent = ({ children, className = '', ...props }) => (
  <div className={`px-6 py-4 ${className}`} {...props}>
    {children}
  </div>
);

export default Card;
